import SlimSelect from "slim-select";

const SELECTOR = "select[data-select-dropdown]";

const instances = new Map<HTMLSelectElement, SlimSelect>();

const enhanceSelect = (select: HTMLSelectElement) => {
  if (instances.has(select)) return;

  const wrapper = select.closest(".c-dropdown__select");
  const slim = new SlimSelect({
    select,
    settings: {
      showSearch: false,
      modal: "off",
      ...(wrapper instanceof HTMLElement
        ? {
            contentLocation: wrapper,
            contentPosition: "relative",
          }
        : {}),
    },
  });

  instances.set(select, slim);
};

const enhanceAll = (root: ParentNode = document) => {
  root.querySelectorAll<HTMLSelectElement>(SELECTOR).forEach(enhanceSelect);
};

const destroySelectsIn = (node: Node) => {
  if (!(node instanceof Element)) return;

  const selects =
    node instanceof HTMLSelectElement && node.matches(SELECTOR)
      ? [node]
      : Array.from(node.querySelectorAll<HTMLSelectElement>(SELECTOR));

  for (const select of selects) {
    const slim = instances.get(select);
    if (!slim || select.isConnected) continue;
    slim.destroy();
    instances.delete(select);
  }
};

export const initSelectDropdowns = () => {
  enhanceAll();

  const observer = new MutationObserver((mutations) => {
    for (const mutation of mutations) {
      mutation.removedNodes.forEach(destroySelectsIn);
      mutation.addedNodes.forEach((node) => {
        if (!(node instanceof Element)) return;

        if (node instanceof HTMLSelectElement && node.matches(SELECTOR)) {
          enhanceSelect(node);
          return;
        }

        enhanceAll(node);
      });
    }
  });

  observer.observe(document.body, { childList: true, subtree: true });
};
